import React, { useEffect, useState } from "react";
import Layout from "../../Layout";
import Container from "../../components/Container";
import { FaHome } from "react-icons/fa";
import { BsCircle, BsCircleFill } from "react-icons/bs";
import { Button } from "../../components/Form";
import { useAppSelector, useAppDispatch } from '../../store';

import { getAllLabs, switchLab } from "../../api/lab";
import { toast } from 'react-toastify';
import Loader from "../../components/Loader";

function SwitchLab() {
	const userData = useAppSelector((state) => state.userData);

	const [lab, setLab] = useState("");
	const [allLabs, setAllLabs] = useState([]);

	const [pageLoader, setPageLoader] = useState(true);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		console.log(userData)
		const fetchData = async () => {
			const res = await getAllLabs();
			if (res) {
				console.log("Labs", res);
				setAllLabs(res);
				setPageLoader(false);
			}
		}

		if (userData?.user?.defaultLabId) {
			setLab(userData.user.defaultLabId);
			fetchData();
		}
	}, [userData]);

	const handleClick = (labID) => {
		setLab(labID);
	};

	const handleSwitchLab = async () => {
		setLoading(true);
		const response = await switchLab({ labId: lab });
		if (response) {
			setLoading(false);
		}
		setLoading(false);
	}

	return (
		<Layout>
			{
				pageLoader ? <Loader /> :
					<Container className={"flex min-w-80"}>
						<div className="flex flex-1 flex-col w-full">
							{allLabs.map((item, index) => (
								<div className="flex flex-1 my-1 items-center" key={index} onClick={() => handleClick(item._id)}>
									<FaHome size={18} />
									<div className="ml-3 text-lg">{item.name}</div>
									{lab === item._id ? (
										<BsCircleFill className="ml-auto" size={18} />
									) : (
										<BsCircle className="ml-auto" size={18} />
									)}
								</div>
							))}
							<div className="flex flex-1 mt-5 bg-green-100">
								<Button className="flex px-4 justify-center items-center" label={"Select"} onClick={handleSwitchLab} loading={loading} />
							</div>
						</div>
					</Container>
			}
		</Layout>
	);
}

export default SwitchLab;
